export default process.env.NODE_ENV === 'production'? {
    url: 'https://chatmrd.herokuapp.com/'
} : {
    url: 'http://192.168.1.102:8082/'
}
